<template>
  <div>
    <a-spin :spinning="pageLoading">
      <tk-flex between style="border-bottom: 1px solid #ccc;" class="m-b-20 p-b-20">
        <div class="font-14 font-bold" style="color: #363B45" >瓜分设置</div>
        <!-- <a-button type="primary" @click="showAdd = true">
          添加
        </a-button> -->
      </tk-flex>
      <div class="full-width m-b-20" v-for="(item, index) in wheelList" :key="index">
        <tk-flex between>
          <div class="font-14 font-bold m-b-20" style="color: #363B45" >第{{index+1}}轮</div>
          <tk-flex v-if="judgeTime(item.openTime)" :gutter="12">
            <!-- <a-button  @click="deleteWheel(index, item)">
              删除
            </a-button> -->
            <a-button type="primary" @click="editWheel(index, item)">
              设置
            </a-button>
          </tk-flex>
        </tk-flex>
        <a-row :gutter="[20,20]" class="font-12 m-b-20" style="color: #363B45" >
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
            瓜分时间：{{ item.openTime | day }}
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
            发放金额：{{ item.total }}
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
            瓜分券数量：{{ item.dividedVoucherNum }}
          </a-col>
        </a-row>
        <a-row :gutter="[20,20]">
          <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" >
            <div class="font-14 font-bold m-b-20" style="color: #363B45" >等级奖励</div>
            <a-table
              class="m-b-20"
              style="width: 100%"
              :columns="columns.slice(0, columns.length - 1)"
              :data-source="item.levelRewards"
              bordered
              :pagination="false"
              size="small"
            >
              <div class="full-width input" slot="amount" slot-scope="item, record">
                {{record.amount}}元
              </div>
              <div class="full-width input" slot="num" slot-scope="item, record">
                {{record.num}}个
              </div>
            </a-table>
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" >
            <div class="font-14 font-bold m-b-20" style="color: #363B45" >必中门店</div>
            <a-table
              style="width: 100%"
              :columns="storeTableColumn.slice(0, storeTableColumn.length - 1)"
              :data-source="item.mustStoreData"
              bordered
              :pagination="false"
              size="small"
            >
              <div class="full-width input" slot="store" slot-scope="item, record">
                {{record.fullName}}
              </div>
              <div class="full-width input" slot="amount" slot-scope="item, record">
                {{record.amount}}元
              </div>
              <div class="full-width input" slot="num" slot-scope="item, record">
                {{record.num}}个
              </div>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <!-- 添加弹窗 -->
    <a-modal
      :visible="showAdd"
      title="新建瓜分奖励"
      :confirmLoading="confirmLoading"
      @ok="save"
      @cancel="close"
      wrapClassName="responsive-modal"
      closable
    >
      <div class="m-b-24">
        <a-tooltip>
          <template slot="title">

          </template>
          当前瓜分券数量：{{dividedVoucherNum}}
        </a-tooltip>
      </div>
      <!-- 表格 -->
      <tk-flex between middle style="width: 100%">
        <div class="font-14 unshrink" style="color: #363B45" >等级奖励：</div>
        <a-button class="editable-add-btn" @click="handleAdd">
          添加
        </a-button>
      </tk-flex>
      <div class="m-t-10">
        <!-- 表格 -->
        <a-table
          v-if="device !== 'mobile'"
          style="width: 100%"
          :columns="columns"
          :data-source="data"
          bordered
          :pagination="false"
          size="small"
        >
          <div class="full-width input" slot="amount" slot-scope="item, record">
            <ak-type-input v-model="record.amount" hideLabel type="Number"  :validators="amountValidators"/>
          </div>
          <div class="full-width input" slot="num" slot-scope="item, record">
            <ak-type-input v-model="record.num" hideLabel type="Number"  :validators="numValidators"/>
          </div>
          <div slot="action" slot-scope="item, record, index">
            <span
              @click="data.splice(index, 1)"
              style="color:#FF2A58;cursor: pointer;">删除</span>
          </div>
        </a-table>
        <div v-else>
          <a-descriptions size="small" bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
            <a-descriptions-item
              v-for="( itm, i) in columns" :key="`item${i}`"
              :label="itm.title"
            >
              <div class="full-width input" v-if="itm.dataIndex === 'amount'">
                <ak-type-input v-model="itm.amount" hideLabel type="Number"  :validators="amountValidators"/>
              </div>
              <div class="full-width input" v-else-if="itm.dataIndex === 'num'">
                <ak-type-input v-model="itm.num" hideLabel type="Number"  :validators="numValidators"/>
              </div>
              <div v-else-if="itm.dataIndex === 'action'">
                <span
                  @click="data.splice(index, 1)"
                  style="color:#FF2A58;cursor: pointer;">删除</span>
              </div>
              <div v-else>{{ item[itm.dataIndex] }}</div>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
      <!-- 必中门店 -->
      <tk-flex between middle style="width: 100%" class="m-t-10">
        <div class="font-14 unshrink" style="color: #363B45" >必中门店：</div>
        <a-button class="editable-add-btn" @click="handleAddStore">
          添加
        </a-button>
      </tk-flex>
      <div class="m-t-10">
         <!-- 表格 -->
         <a-table
          v-if="device !== 'mobile'"
          style="width: 100%"
          :columns="storeTableColumn"
          :data-source="storeTableData"
          bordered
          :pagination="false"
          size="small"
        >
          <div class="full-width input" slot="store" slot-scope="item, record">
            <ak-type-input v-model="record.store" hideLabel :field="storeField" />
          </div>
          <div class="full-width input" slot="amount" slot-scope="item, record">
            <ak-type-input v-model="record.amount" hideLabel type="Number"  :validators="amountValidators"/>
          </div>
          <div class="full-width input" slot="num" slot-scope="item, record">
            <ak-type-input v-model="record.num" hideLabel type="Number"  :validators="numValidators"/>
          </div>
          <div slot="action" slot-scope="item, record, index">
            <span
              @click="storeTableData.splice(index, 1)"
              style="color:#FF2A58;cursor: pointer;">删除</span>
          </div>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import NP from 'number-precision'
export default {
  props: {
    marketingCampaign: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      moment: moment,
      pageLoading: true,
      wheelList: [],
      showAdd: false,
      confirmLoading: false,
      openTime: '',
      totalNum: 0,
      data: [],
      columns: [
        {
          title: '等级奖励',
          dataIndex: 'amount',
          key: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: '40%'
        },
        {
          title: '数量',
          dataIndex: 'num',
          key: 'num',
          scopedSlots: { customRender: 'num' },
          width: '40%'
        },
        {
          title: '操作',
          key: 'action',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '20%'
        }
      ],
      amountValidators: [
        (val) => val ? null : '不可为空',
        (val) => val >= 0.1 && val <= 200 ? null : '等级奖励为0.1-200元之间',
        value => {
          if (!value) return null
          let reg = /^(\d+)(.\d{0,2})?$/
          return reg.test(value) ? null : '等级奖励最多为两位小数'
        }
      ],
      numValidators: [
        (val) => val || val === 0 ? null : '不可为空',
        (value) => {
          let reg = /^\d+$/
          return reg.test(value) ? null : '数量必须为正整数'
        }
      ],
      selectWheel: null, // 要修改的轮
      dividedVoucherNum: 0,
      storeTableData: [],
      storeTableColumn: [
        {
          title: '门店',
          dataIndex: 'store',
          key: 'store',
          scopedSlots: { customRender: 'store' },
          width: '40%'
        },
        {
          title: '等级奖励',
          dataIndex: 'amount',
          key: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: '20%'
        },
        {
          title: '数量',
          dataIndex: 'num',
          key: 'num',
          scopedSlots: { customRender: 'num' },
          width: '20%'
        },
        {
          title: '操作',
          key: 'action',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '20%'
        }
      ],
      storeField: {
        name: 'store',
        note: '名称',
        type: 'Pointer',
        searchKey: ['fullName'],
        targetClass: 'store',
        validators: [
          (val) => val ? null : '不可为空'
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.storeField.listWhere = (where) => {
        where.isDelete = false
        where.status = 'pass'
        if (this.marketingCampaign.type === '0') {
          where.agent = {
            $in: this.marketingCampaign.agent
          }
        }
      }
      let { data: res } = await this.$tkParse.get(`/classes/wheel`, {
        params: {
          order: 'openTime',
          where: {
            marketingCampaign: this.marketingCampaign.objectId,
            isDelete: false
          }
        }
      })
      for (let i = 0; i < res.results.length; i++) {
        let e = res.results[i]
        let levelRewards = e.basicLevelRewards ? JSON.parse(e.basicLevelRewards) : []
        let mustStoreData = e.basicMustStoreData ? JSON.parse(e.basicMustStoreData) : []
        let total = 0
        levelRewards.forEach(i => {
          total = NP.plus(total, NP.times(i.amount, i.num))
        })
        mustStoreData.forEach(i => {
          total = NP.plus(total, NP.times(i.amount, i.num))
        })
        // 获取瓜分券数量
        let dividedVoucherNum = await this.getDividedVoucher(e.objectId)
        let storeList = await this.getStore(mustStoreData.map(e => e.store))
        mustStoreData.map(e => {
          let item = storeList.find(i => i.objectId === e.store)
          e.fullName = item ? item.fullName : ''
        })
        this.wheelList.push({
          objectId: e.objectId,
          openTime: e.openTime,
          levelRewards: levelRewards,
          total: total,
          dividedVoucherNum: dividedVoucherNum,
          mustStoreData: mustStoreData
        })
      }
      // this.totalNum = await this.getDividedVoucher()
      this.pageLoading = false
    },
    // 统计瓜分券
    async getDividedVoucher (wheel) {
      let { data: res } = await this.$tkParse.get(`/aggregate/dividedVoucher`, {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: 1
            }
          },
          match: {
            marketingCampaign: this.marketingCampaign.objectId,
            wheel: wheel
            // createdAt: {
            //   $lte: endTime ? new Date(new Date(endTime).setHours(23, 59, 59, 999)).toISOString() : this.marketingCampaign.endDate
            // }
          }
        }
      })
      let num = 0
      // if (endTime) {
      num = res.results.reduce((value, item) => value + item.total, 0)
      // } else {
      //   let item = res.results.find(e => e.objectId === 'toBeUsed')
      //   num = item ? item.total : 0
      // }
      return num
    },
    // 获取门店信息
    async getStore (list) {
      let { data: res } = await this.$tkParse.get('/classes/store', {
        params: {
          keys: 'fullName',
          where: {
            objectId: {
              $in: list
            }
          }
        }
      })
      return res.results
    },
    onChange (date, dateString) {
      this.openTime = dateString
    },
    disabledDate (current) {
      return current && (current < moment().subtract(1, 'days') || current > moment(this.marketingCampaign.endDate)) // 当前日期之前不能选择（不含当前日）
    },
    handleAdd () {
      this.data.push({
        amount: null,
        num: null
      })
    },
    handleAddStore () {
      this.storeTableData.push({
        store: null,
        amount: null,
        num: null
      })
    },
    // 关闭弹窗
    close () {
      this.showAdd = false
      this.data = []
      this.storeTableData = []
    },
    // 删除轮
    deleteWheel (index, item) {
      this.$confirm({
        title: '警告',
        content: '您确定要删除该奖励吗？',
        onOk: async () => {
          await this.$tkParse.put(`/classes/wheel/${item.objectId}`, {
            isDelete: true
          })
          this.wheelList.splice(index, 1)
        }
      })
    },
    // 编辑轮
    editWheel (index, item) {
      this.showAdd = true
      this.openTime = item.openTime
      // 等级奖励
      item.levelRewards.forEach(e => {
        this.data.push({
          amount: e.amount,
          num: e.num
        })
      })
      this.selectWheel = item.objectId
      this.dividedVoucherNum = item.dividedVoucherNum
      item.mustStoreData.forEach(e => {
        this.storeTableData.push({
          store: e.store,
          amount: e.amount,
          num: e.num
        })
      })
    },

    // 保存
    async save () {
      try {
        this.confirmLoading = true
        // if (!this.openTime) {
        //   this.$notification['warning']({
        //     message: '警告',
        //     description: '开奖时间不可为空'
        //   })
        //   this.confirmLoading = false
        //   return
        // }
        let bool = this.data.every(e => {
          if ((e.amount && e.amount >= 0.1 && e.amount <= 200) && e.amount && /^(\d+)(.\d{0,2})?$/.test(e.amount) && (e.num || e.num === 0) && /^\d+$/.test(e.num)) return true
        })
        if (!bool) {
          this.confirmLoading = false
          return
        }
        if (this.storeTableData.length) {
          let bool = this.storeTableData.every(e => {
            let item = this.data.find(i => i.amount === e.amount)
            if (e.amount && e.num && e.store && item) return true
            return false
          })
          if (!bool) {
            this.$notification['warning']({
              message: '警告',
              description: '必中门店等级奖励未找到'
            })
            this.confirmLoading = false
            return
          }
        }
        if (this.selectWheel) {
          // 编辑
          await this.$tkParse.put(`/classes/wheel/${this.selectWheel}`, {
            // openTime: new Date(moment(this.openTime).format('YYYY-MM-DD HH:mm:ss')).toISOString(),
            levelRewards: JSON.stringify(this.data),
            basicLevelRewards: JSON.stringify(this.data), // 原始数据
            mustStoreData: JSON.stringify(this.storeTableData),
            basicMustStoreData: JSON.stringify(this.storeTableData)
          })
          let total = 0
          this.data.forEach(i => {
            total += i.amount * i.num
          })
          this.storeTableData.forEach(i => {
            total += i.amount * i.num
          })
          let storeList = await this.getStore(this.storeTableData.map(e => e.store))
          this.storeTableData.map(e => {
            let item = storeList.find(i => i.objectId === e.store)
            e.fullName = item ? item.fullName : ''
          })
          let index = this.wheelList.findIndex(e => e.objectId === this.selectWheel)
          this.wheelList[index].levelRewards = this.data
          this.wheelList[index].mustStoreData = this.storeTableData // 设置必中
          this.wheelList[index].total = total
          this.selectWheel = null
        }
        //  else {
        //   // 创建轮
        //   let res = await this.$tkParse.post(`/classes/wheel`, {
        //     marketingCampaign: this.marketingCampaign.objectId,
        //     openTime: new Date(moment(this.openTime).format('YYYY-MM-DD HH:mm:ss')).toISOString(),
        //     levelRewards: JSON.stringify(this.data),
        //     basicLevelRewards: JSON.stringify(this.data), // 原始数据
        //     isDelete: false
        //   })
        //   // 增加活动预计开奖时间
        //   let total = 0
        //   this.data.forEach(i => {
        //     total += i.amount * i.num
        //   })
        //   this.wheelList.push({
        //     objectId: res.objectId,
        //     openTime: new Date(moment(this.openTime).format('YYYY-MM-DD HH:mm:ss')).toISOString(),
        //     levelRewards: this.data,
        //     total: total
        //   })
        // }
        this.confirmLoading = false
        this.close()
        this.$notification['success']({
          message: '操作成功',
          description: '保存成功'
        })
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '网络错误',
          description: '保存失败'
        })
        this.confirmLoading = false
      }
    },
    judgeTime (time) {
      return new Date().getTime() < new Date(new Date(time).setHours(23, 59, 59, 999)).getTime()
    }
  }
}
</script>
<style lang="scss" scoped>
  .input .ant-form-item{
    margin-bottom: 0;
  }
</style>
